export const getCurrencyListMock = {
	currencyList: ['AUD', 'CAD', 'CHF', 'USDT'],
	returnCode: '0',
	message: '',
};

export default getCurrencyListMock;
